import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Missouri = () => {
  return (
    <StatePropertyTaxPage
      stateName="Missouri"
      processDescription="Property owners may appeal their assessment by filing a complaint with the local Board of Equalization. Appeals must be filed by the specified deadline, and hearings are conducted to review evidence of property value."
      noticeOfValueMailed="May"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in May to allow time for the appeal process before tax bills are finalized."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Missouri assesses property as of January 1 each year. This assessment date captures the property's market value and condition at the beginning of each calendar year for consistent statewide valuations."
      deadlineExplanation="Property owners typically have 30 days from the notice mailing date to file appeals with the local Board of Equalization. The exact deadline varies by county but generally falls in June."
    />
  );
};

export default Missouri;